import { render, staticRenderFns } from "./sample-item-boxes.vue?vue&type=template&id=301af37d&"
import script from "./sample-item-boxes.vue?vue&type=script&lang=js&"
export * from "./sample-item-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports